import { choosePlatform } from '../../../helpers/utils';

interface IProps {
	style: string;
	color?: string;
}

export const Beginner = ({
	style,
	color = choosePlatform() ? '#35168C' : '#DF1737',
}: IProps) => {
	return (
		<svg
			width="158"
			height="212"
			viewBox="0 0 158 212"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={style}
		>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H150C154.418 0 158 3.58172 158 8V177.863C158 181.233 155.887 184.243 152.717 185.387L81.7165 211.019C79.961 211.653 78.039 211.653 76.2835 211.019L5.28349 185.387C2.11293 184.243 0 181.233 0 177.863V8Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M82.0143 64.6121L88.7231 79.1614C88.7908 79.3169 88.8995 79.4515 89.0378 79.5509C89.1761 79.6503 89.3389 79.7109 89.509 79.7263L105.542 81.5548C106.07 81.6123 106.57 81.8196 106.982 82.1518C107.394 82.484 107.701 82.927 107.865 83.4277C108.029 83.9283 108.044 84.4653 107.908 84.9742C107.772 85.483 107.49 85.9421 107.097 86.2964L95.211 97.1153C95.0818 97.227 94.9855 97.3713 94.9323 97.5329C94.8791 97.6944 94.871 97.8673 94.9089 98.033L98.1088 113.712C98.2173 114.227 98.1733 114.762 97.9821 115.253C97.791 115.744 97.4607 116.17 97.0311 116.479C96.6016 116.788 96.091 116.968 95.5609 116.996C95.0308 117.024 94.5038 116.9 94.0432 116.638L79.9878 108.777C79.8399 108.692 79.6719 108.647 79.5008 108.647C79.3298 108.647 79.1618 108.692 79.0138 108.777L64.9553 116.638C64.4946 116.899 63.9678 117.023 63.4381 116.994C62.9084 116.966 62.3982 116.786 61.969 116.477C61.5397 116.168 61.2096 115.743 61.0182 115.252C60.8269 114.762 60.7825 114.227 60.8903 113.712L64.0902 98.033C64.1281 97.8673 64.12 97.6944 64.0669 97.5329C64.0137 97.3713 63.9174 97.227 63.7881 97.1153L51.9042 86.2951C51.5108 85.9411 51.2289 85.482 51.0925 84.973C50.956 84.464 50.9708 83.9267 51.1351 83.4259C51.2994 82.925 51.6062 82.4818 52.0186 82.1497C52.4309 81.8175 52.9313 81.6105 53.4595 81.5535L69.4952 79.7251C69.6653 79.7096 69.8281 79.649 69.9664 79.5496C70.1047 79.4502 70.2134 79.3156 70.2811 79.1601L76.9874 64.6121C77.205 64.1318 77.558 63.7242 78.004 63.4382C78.4499 63.1522 78.9697 63 79.5008 63C80.032 63 80.5518 63.1522 80.9977 63.4382C81.4436 63.7242 81.7967 64.1318 82.0143 64.6121Z"
				fill="white"
			/>
		</svg>
	);
};
